// import React from 'react';
//
// const MapSection = () => {
//   return (
//     <section className="map-section map-style-9">
//       <div className="map-container">
//         <iframe
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3102.7887109309127!2d-77.44196278417968!3d38.95165507956235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzjCsDU3JzA2LjAiTiA3N8KwMjYnMjMuMiJX!5e0!3m2!1sen!2sbd!4v1545420879707"
//           style={{ border: 0, height: '500px', width: '100%' }}
//           allowFullScreen=""
//           loading="lazy"
//           referrerPolicy="no-referrer-when-downgrade"
//           title="Z1 Technology Location"
//         ></iframe>
//       </div>
//     </section>
//   );
// };
//
// export default MapSection;
import React from 'react';

const MapSection = () => {
  return (
    <section className="map-section map-style-9">
      <div className="map-container">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3538.7556134668152!2d83.44873807568175!3d27.507974876297375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39969b521428599f%3A0xbd5c8fdd63570c2a!2sZ1%20Technology%20%26%20Trade%20Pvt.Ltd!5e0!3m2!1sen!2snp!4v1766417226404!5m2!1sen!2snp"
        width="100%" height="500"
          referrerpolicy="no-referrer-when-downgrade"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Z1 Technology Location Map"
        ></iframe>
      </div>
    </section>
  );
};

export default MapSection;